import { useQuery } from "@apollo/client/react";
import { getCurrentUserQuery } from "../../logic/user";
import { useEffect, useState } from "react";

function useAuthCheck () {
    const currentUserQuery = useQuery(getCurrentUserQuery);
    const [currentUser, setCurrentUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        setIsLoading(currentUserQuery?.loading);
    }, [currentUserQuery?.loading]);
    
    useEffect(() => {
        const user = currentUserQuery?.data?.classMethods?.User?.getCurrentUser;

        if (user) {
            setCurrentUser(user);
            setIsLoggedIn(true);
        } else {
            setCurrentUser(null);
            setIsLoggedIn(false);
        }
    }, [currentUserQuery?.data]);

    return {isLoading, isLoggedIn, currentUser, refetchUserData: currentUserQuery?.refetch, setIsLoggedIn};
}

export default useAuthCheck;